import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arabicTimeFormat'
})
export class ArabicTimeFormatPipe implements PipeTransform {
  transform(time: string): string {
    if (!time) return '';

    const [hours, minutes] = time.split(':').map(Number);
    
    if (isNaN(hours) || isNaN(minutes)) return time;

    // Determine AM (ص) or PM (م)
    const period = hours >= 12 ? 'م' : 'ص';
    
    // Convert to 12-hour format
    let hour12 = hours % 12;
    hour12 = hour12 === 0 ? 12 : hour12;
    
    // Format minutes with leading zero
    const minutesFormatted = minutes.toString().padStart(2, '0');
    
    return `${hour12}:${minutesFormatted} ${period}`;
  }
}
